import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PermissionsService } from '../services/permissions.service';

@Injectable({
    providedIn: 'root'
})
export class RosteringGuard {
    constructor(private permissionsService: PermissionsService) {}

    canActivate(features: Array<'roster' | 'reallocate'> = ['roster', 'reallocate']): Observable<boolean> {
        // Allow access if user has any of the given permissions (default: roster or reallocate)
        return this.permissionsService.hasAnyFeatureAccess(features);
    }
}
